import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { facilityQueryKeys } from "./facilityQueryKeys";

export const useMutationDeleteFacility = ({ api }: { api: ApiType }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (facilityId: number) => api.facilityApi.delete(facilityId),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: facilityQueryKeys.all(),
      }),
  });
};
